import React, { PropTypes } from 'react';
import SettingsEditForm from '../SettingsEditForm';

class SettingsEdit extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    model: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
  };

  state = {
    loading: true,
    value: null
  };

  componentWillMount() {
    this.props.fetch();
  }

  componentWillReceiveProps(newProps) {
    let {
        loading
      } = this.state;

    loading = loading && newProps.loading;

    this.setState({
      loading
    });
  }

  save(data) {
    return this.props.save(data);
  }

  render() {
    let { loading } = this.state;

    return (
      <div>
        { loading
          ? (<div>Loading...</div>)
          : (
          <SettingsEditForm
            submit={(data) => this.save(data)}
            cancel={this.props.cancel}
          />
        )
        }
      </div>
    );
  }
}

export default SettingsEdit;




// WEBPACK FOOTER //
// ./src/components/Settings/SettingsEdit/SettingsEdit.jsx